import * as actions from '../../actions/current'

export const getCurrentInitialState = () => null

export default (state = getCurrentInitialState(), action = {}) => {
  switch (action.type) {
    case actions.INS_CURRENT_SET: {
      return action.payload
    }
    default:
  }
  return state
}
